/* eslint-disable */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";
import { useTranslation } from "react-i18next";

import * as url from "helper/UrlHelper";
import { getData, postData } from "utils/Gateway";
import NoteModuleListOptions from "data/Prod/NoteModuleList.json";
import { reactSelectStyle } from "Config/Config";

const AddNewNotePopup = ({
  afterPopupClose = () => {},
  setShowAlert,
  setAlertMessage,
  setMessageType,
}) => {
  const token = localStorage.getItem("token");
  const { t } = useTranslation();
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  const NoteModuleList = NoteModuleListOptions.map((item) => ({
    value: item.value,
    label: t(item.label),
  }));

  const [selectedModuleType, setSelectedModuleType] = useState(null);
  const [noteModuleName, setNoteModuleName] = useState("");
  const [leadInput, setleadInput] = useState("");
  const [contactInput, setcontactInput] = useState("");
  const [opportunityInput, setOpportunityInput] = useState("");
  const [leadOptions, setleadOptions] = useState([]);
  const [contactOptions, setcontactOptions] = useState([]);
  const [opportunityOptions, setOpportunityOptions] = useState([]);
  const [noteLeadValue, setNoteLeadValue] = useState(null);
  const [noteLeadId, setNoteLeadId] = useState(null);
  const [noteContactValue, setNoteContactValue] = useState(null);
  const [noteContactId, setNoteContactId] = useState(null);
  const [noteContactPersonId, setNoteContactPersonId] = useState(null);
  const [noteOpportunityValue, setNoteOpportunityValue] = useState(null);
  const [noteOpportunityId, setNoteOpportunityId] = useState(null);
  const [noteAccessUserList, setnoteAccessUserList] = useState([]);
  const [title, settitle] = useState("");
  const [description, setdescription] = useState("");
  const [isPrivate, setIsPrivate] = useState(false);
  const [isSaving, setIsSaving] = useState(false);

  // Validation state from SaveInvoiceForm
  const [errors, setErrors] = useState({});

  // Validation function adapted for this component
  const validateForm = () => {
    const newErrors = {};

    if (!selectedModuleType) {
      newErrors.type = t("Please select a module.");
    }
    if (
      selectedModuleType &&
      !noteLeadId &&
      !noteContactId &&
      !noteOpportunityId
    ) {
      newErrors.moduleId = t("Please select an item for the chosen module.");
    }
    if (!title.trim()) {
      newErrors.title = t("Please enter a title.");
    }
    // Removed validation for description
    // if (!description.trim()) {
    //   newErrors.details = t("Description is required");
    // }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const noteTypeSelectionHandler = (val) => {
    if (errors.type) setErrors((prev) => ({ ...prev, type: "" }));
    if (errors.moduleId) setErrors((prev) => ({ ...prev, moduleId: "" }));

    setSelectedModuleType(val);
    setNoteModuleName(val ? val.value : "");
    setleadInput("");
    setcontactInput("");
    setleadOptions([]);
    setcontactOptions([]);
    setNoteLeadId(null);
    setNoteLeadValue(null);
    setNoteContactId(null);
    setNoteContactValue(null);
    setNoteContactPersonId(null);
    setNoteOpportunityId(null);
    setNoteOpportunityValue(null);
  };

  const leadInputChangeHandler = (val) => setleadInput(val);
  const opportunityInputHandler = (val) => setOpportunityInput(val);
  const contactInputChangeHandler = (val) => setcontactInput(val);

  const getLeadOptions = async () => {
    try {
      let requestUrl = `${url.API_BASE_URL}${url.API_GET_ALL_LEAD_OPTIONS}?leadstringinput=${leadInput}`;
      const response = await getData(requestUrl);
      if (response.status) setleadOptions(response.data);
    } catch (error) {
      console.error(error.message);
    }
  };

  const getContactOptions = async () => {
    try {
      let requestUrl = `${url.API_BASE_URL}${url.API_GET_ALL_CONTACTS_OPTIONS}?userstring=${contactInput}`;
      const response = await getData(requestUrl);
      if (response.status) setcontactOptions(response.data);
    } catch (error) {
      console.error(error.message);
    }
  };

  const getOpportunityOptions = async () => {
    try {
      let requestUrl = `${url.API_BASE_URL}${url.API_GET_INVOICE_LIST_OPTIONS}?invoicetitle=${opportunityInput}`;
      const response = await getData(requestUrl);
      if (response.status) setOpportunityOptions(response.data);
    } catch (error) {
      console.error(error.message);
    }
  };

  const leadSelectionHandler = (val) => {
    if (errors.moduleId) setErrors((prev) => ({ ...prev, moduleId: "" }));
    if (val) {
      setNoteLeadValue(val);
      setNoteLeadId(val.value);
      getLeadDetails(val.value);
    } else {
      setNoteLeadValue(null);
      setNoteLeadId(null);
      setleadInput("");
      setleadOptions([]);
      setnoteAccessUserList([]);
    }
  };

  const contactSelectionHandler = (val) => {
    if (errors.moduleId) setErrors((prev) => ({ ...prev, moduleId: "" }));
    if (val) {
      setNoteContactValue(val);
      setNoteContactId(val._id);
      setNoteContactPersonId(val.value);
      getContactUserDetails(val.value);
    } else {
      setNoteContactValue(null);
      setNoteContactId(null);
      setNoteContactPersonId(null);
      setcontactInput("");
      setcontactOptions([]);
    }
    setnoteAccessUserList([]);
  };

  const opportunitySelectionHandler = (val) => {
    if (errors.moduleId) setErrors((prev) => ({ ...prev, moduleId: "" }));
    if (val) {
      setNoteOpportunityValue(val);
      setNoteOpportunityId(val.value);
      getOpportunityDetails(val.value);
    } else {
      setNoteOpportunityValue(null);
      setNoteOpportunityId(null);
      setOpportunityInput("");
      setOpportunityOptions([]);
      setnoteAccessUserList([]);
    }
  };

  const saveNote = async () => {
    if (!validateForm()) {
      return;
    }
    try {
      setIsSaving(true);
      let noteData = {
        notetype: "1",
        title,
        details: description,
        isprivate: isPrivate,
        noteaccessusers: isPrivate ? [] : noteAccessUserList,
      };
      if (noteLeadId) noteData.leadid = noteLeadId;
      if (noteContactId) noteData.contactid = noteContactId;
      if (noteOpportunityId) noteData.invoiceid = noteOpportunityId;

      let requestUrl = `${url.API_BASE_URL}${url.API_ADD_NEW_NOTE}`;
      const response = await postData(requestUrl, noteData);
      setIsSaving(false);

      if (response.status) {
        setMessageType("success");
        bootstrap.Offcanvas.getInstance(
          document.querySelector("#addNewNote")
        ).hide();
        resetHandler();
        afterPopupClose();
      } else {
        setMessageType("error");
      }
      setAlertMessage(response.message);
    } catch (error) {
      setAlertMessage(error.message);
      setMessageType("error");
    }
    setShowAlert(true);
  };

  const resetHandler = () => {
    setErrors({});
    setSelectedModuleType(null);
    setNoteModuleName("");
    setleadInput("");
    setcontactInput("");
    setOpportunityInput("");
    setleadOptions([]);
    setcontactOptions([]);
    setOpportunityOptions([]);
    setNoteLeadId(null);
    setNoteLeadValue(null);
    setNoteContactId(null);
    setNoteContactValue(null);
    setNoteContactPersonId(null);
    setNoteOpportunityValue(null);
    setNoteOpportunityId(null);
    setnoteAccessUserList([]);
    settitle("");
    setdescription("");
  };

  const getLeadDetails = async (leadId) => {
    if (!leadId) return;
    try {
      let requestUrl = `${url.API_BASE_URL}${url.API_GET_LEAD_DETAILS}/${leadId}`;
      const response = await getData(requestUrl);
      if (response.status) {
        const { followers, moderator } = response.data;
        const allFollowerIds = followers?.map((item) => item._id) || [];
        const appendedNoteFollowers = [...allFollowerIds, moderator._id];
        setnoteAccessUserList(
          appendedNoteFollowers.filter(
            (id) => id.toString() !== userInfo._id.toString()
          )
        );
      }
    } catch (error) {
      console.error(error.message);
    }
  };

  const getContactUserDetails = async (userId) => {
    if (!userId) return;
    setnoteAccessUserList([]);
  };

  const getOpportunityDetails = async (opportunityId) => {
    if (!opportunityId) return;
    try {
      let requestUrl = `${url.API_BASE_URL}${url.API_INVOICE_DETAILS}/${opportunityId}`;
      const response = await getData(requestUrl);
      if (response.status) {
        const { followers, user } = response.data;
        const allFollowerIds = followers?.map((item) => item._id) || [];
        const appendedNoteFollowers = [...allFollowerIds, user._id];
        setnoteAccessUserList(
          appendedNoteFollowers.filter(
            (id) => id.toString() !== userInfo._id.toString()
          )
        );
      }
    } catch (error) {
      console.error(error.message);
    }
  };

  useEffect(() => {
    if (leadInput.length > 0) getLeadOptions();
  }, [leadInput]);

  useEffect(() => {
    if (contactInput.length > 0) getContactOptions();
  }, [contactInput]);

  useEffect(() => {
    if (opportunityInput.length > 0) getOpportunityOptions();
  }, [opportunityInput]);

  const customStyle = {
    control: (base, state) => ({
      ...base,
      borderColor: errors.moduleId || errors.type ? "#dc3545" : "#ced4da",
      "&:hover": {
        borderColor: errors.moduleId || errors.type ? "#dc3545" : "#ced4da",
      },
      borderRadius: "7px",
      padding: "3px",
      minHeight: "40px",
      boxShadow: "none",
    }),
  };

  return (
    <div
      className="offcanvas invoice_w offcanvas-end bg-white border-0"
      tabIndex="-1"
      id="addNewNote"
      aria-labelledby="addNewNote"
    >
      <div className="offcanvas-header bg-primary text-white p-4 pe-5 pb-3 border-bottom border-gray-300">
        <div className="d-flex align-items-center gap-3">
          <div className="icon-wrapper p-3 bg-white rounded-circle d-flex align-items-center justify-content-center">
            <span className="material-symbols-outlined text-primary fs-5 icon-md">
              note_add
            </span>{" "}
          </div>
          <div>
            <h3
              className="offcanvas-title fw-bold text-white mb-0"
              id="offcanvasLabelDetailsLabel"
            >
              {t("Add New Note")}
            </h3>
            <p className="text-white fs-sm mb-0">
              {t("Create a new note for a module")}
            </p>
          </div>
        </div>
        <button
          type="button"
          className="btn-close p-1 bg-gray-200 rounded-circle shadow-sm border-0"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
          onClick={resetHandler}
        ></button>
      </div>
      <div className="offcanvas-body p-4">
        <div className="row">
          <div className="col-lg-12">
            <div className="p-3 p-md-4 border border-gray-300 rounded-10 shadow-sm">
              <form
                onSubmit={(e) => e.preventDefault()}
                className="d-flex flex-column h-100"
              >
                <div className="fields-container flex-fill">
                  <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                    <label
                      htmlFor="moduleType"
                      className="d-block fs-sm fw-semibold mb-2 text-dark"
                    >
                      {t("Module")}
                    </label>
                    <Select
                      id="moduleType"
                      isClearable
                      styles={customStyle}
                      placeholder={t(
                        "Choose a module (e.g., Lead, Contact, Opportunity)"
                      )}
                      options={NoteModuleList}
                      value={selectedModuleType}
                      onChange={noteTypeSelectionHandler}
                    />
                    {errors.type && (
                      <div className="invalid-feedback d-block">
                        {errors.type}
                      </div>
                    )}
                  </div>

                  {selectedModuleType && (
                    <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                      <label
                        htmlFor="componentSelect"
                        className="d-block fs-sm fw-semibold mb-2 text-dark"
                      >
                        {t("Select Component")}
                      </label>
                      {selectedModuleType.value === "lead" ? (
                        <Select
                          id="componentSelect"
                          isClearable
                          styles={customStyle}
                          placeholder={t("Search by lead name or email")}
                          options={leadOptions}
                          value={noteLeadValue}
                          onChange={leadSelectionHandler}
                          onInputChange={leadInputChangeHandler}
                        />
                      ) : selectedModuleType.value === "opportunity" ? (
                        <Select
                          id="componentSelect"
                          isClearable
                          styles={customStyle}
                          placeholder={t("Search by opportunity title")}
                          options={opportunityOptions}
                          value={noteOpportunityValue}
                          onChange={opportunitySelectionHandler}
                          onInputChange={opportunityInputHandler}
                        />
                      ) : (
                        <Select
                          id="componentSelect"
                          isClearable
                          styles={customStyle}
                          placeholder={t("Search by contact name")}
                          options={contactOptions}
                          value={noteContactValue}
                          onChange={contactSelectionHandler}
                          onInputChange={contactInputChangeHandler}
                        />
                      )}
                      {errors.moduleId && (
                        <div className="invalid-feedback d-block">
                          {errors.moduleId}
                        </div>
                      )}
                    </div>
                  )}

                  <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                    <label
                      htmlFor="title"
                      className="d-block fs-sm fw-semibold mb-2 text-dark"
                    >
                      {t("Title")}
                    </label>
                    <input
                      type="text"
                      id="title"
                      className={`form-control fs-sm shadow-none ${
                        errors.title ? "is-invalid" : "border border-gray-300"
                      }`}
                      placeholder={t("Enter a concise title for the note")}
                      value={title}
                      onChange={(e) => {
                        settitle(e.target.value);
                        if (errors.title)
                          setErrors((prev) => ({ ...prev, title: "" }));
                      }}
                    />
                    {errors.title && (
                      <div className="invalid-feedback">{errors.title}</div>
                    )}
                  </div>

                  <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                    <label
                      htmlFor="description"
                      className="d-block fs-sm fw-semibold mb-2 text-dark"
                    >
                      {t("Description")}
                    </label>
                    <textarea
                      id="description"
                      rows="5"
                      className="form-control fs-sm shadow-none border border-gray-300"
                      placeholder={t(
                        "Provide detailed information for the note"
                      )}
                      value={description}
                      onChange={(e) => setdescription(e.target.value)}
                    ></textarea>
                  </div>

                  <div className="form-group d-flex align-items-center gap-2 mb-4 p-3 border rounded-8 shadow-sm bg-white">
                    <div className="form-check d-flex align-items-center gap-2 fs-sm p-0 m-0">
                      <input
                        className="form-check-input bg-transparent border-2 border-gray-600 shadow-none m-0"
                        type="checkbox"
                        checked={isPrivate}
                        onChange={(e) => setIsPrivate(e.target.checked)}
                      />
                      <label
                        className="form-check-label fw-semibold text-dark"
                        htmlFor="isPrivate"
                      >
                        {t("Mark as Private")}
                      </label>
                    </div>
                  </div>
                </div>

                <div className="action d-flex justify-content-end pt-4 border-top mt-auto">
                  <button
                    onClick={saveNote}
                    type="button"
                    className="btn btn-primary"
                    disabled={isSaving}
                    style={{
                      cursor: isSaving ? "not-allowed" : "pointer",
                    }}
                  >
                    {t("Add New Note")}
                    {isSaving && (
                      <div
                        className="mx-2 spinner-border spinner-border-sm"
                        role="status"
                      >
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddNewNotePopup;
